import { fallbackBasicColor as r } from "./highrise68.mjs";
import { fallbackVariant as a } from "./highrise440.mjs";
const t = {
  default: {
    leftButton: {
      variant: a("secondary"),
      color: r("gray"),
      label: "Back",
      show: !0
    },
    rightSecondary: {
      variant: a("secondary"),
      color: r("gray"),
      label: "Cancel",
      show: !0
    },
    rightPrimary: {
      variant: a("primary"),
      color: r("blue"),
      label: "Continue",
      show: !0
    }
  },
  info: {
    leftButton: {
      show: !1
    },
    rightSecondary: {
      variant: a("secondary"),
      color: r("gray"),
      label: "Cancel",
      show: !0
    },
    rightPrimary: {
      variant: a("primary"),
      color: r("blue"),
      label: "Continue",
      show: !0
    }
  },
  success: {
    leftButton: {
      show: !1
    },
    rightSecondary: {
      show: !1
    },
    rightPrimary: {
      variant: a("primary"),
      color: r("blue"),
      label: "Continue",
      show: !0
    }
  },
  warning: {
    leftButton: {
      variant: a("secondary"),
      color: r("red"),
      label: "Discard",
      show: !0
    },
    rightSecondary: {
      variant: a("secondary"),
      color: r("gray"),
      label: "Cancel",
      show: !0
    },
    rightPrimary: {
      variant: a("primary"),
      color: r("blue"),
      label: "Save Changes",
      show: !0
    }
  },
  error: {
    leftButton: {
      variant: a("secondary"),
      color: r("red"),
      label: "Discard",
      show: !0
    },
    rightSecondary: {
      variant: a("secondary"),
      color: r("gray"),
      label: "Cancel",
      show: !0
    },
    rightPrimary: {
      variant: a("primary"),
      color: r("red"),
      label: "Yes, Delete",
      show: !0
    }
  }
};
export {
  t as default
};
